// Presentation only. Nothing in this file decides anything.

const DT = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

const D = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
})

export function dateTime(value) {
  if (!value) return null
  const d = new Date(value)
  return Number.isNaN(+d) ? null : DT.format(d)
}

export function date(value) {
  if (!value) return null
  const d = new Date(value)
  return Number.isNaN(+d) ? null : D.format(d)
}

export function bytes(n) {
  if (n == null) return null
  if (n < 1024) return `${n} B`
  const units = ['KB', 'MB', 'GB']
  let v = n / 1024
  let i = 0
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024
    i += 1
  }
  return `${v < 10 ? v.toFixed(1) : Math.round(v)} ${units[i]}`
}

/** A stage key, a role, a status, an event name — all arrive as
 *  snake_case from the database. Rendered as words, with the key kept
 *  available for anything that needs to match on it.
 *
 *  THIS IS NOT A LOOKUP TABLE. There is no map from key to label
 *  anywhere in this application, because stages, case types and roles
 *  are tenant-defined (migration 053 deliberately put no CHECK on
 *  er_cases.current_stage) and a map here would be a hardcoded stage
 *  list arriving through the back door. Where the backend supplies a
 *  label — StageItem.label, case_type_label — that label is used and
 *  this function is not called. */
export function words(key) {
  if (!key) return ''
  return String(key).replace(/_/g, ' ')
}

/** A sha256, shortened for display. The full value is always in the
 *  title attribute — it is the answer to "is the file I am holding the
 *  file that was attached", so it must be copyable in full. */
export function shortHash(hash) {
  if (!hash) return ''
  return `${hash.slice(0, 8)}…${hash.slice(-6)}`
}

export function pluralise(n, one, many) {
  return `${n} ${n === 1 ? one : many}`
}

/** Working days, as the backend counts them.
 *
 *  Rendered, never computed. `working_days_outstanding` comes from
 *  stages.count_working_days — the same arithmetic as the policy clock,
 *  so a chaser on a note confirmation and a breach badge on the case
 *  cannot disagree about what a working day is. Recomputing it here
 *  would introduce exactly that disagreement, and this client does not
 *  know the tenant's calendar. */
export function workingDays(n) {
  return pluralise(n, 'working day', 'working days')
}
